<template>
  <div id="app">
    <transition name="fade-transform" mode="out-in">
      <router-view :key="key" />
    </transition>

  </div>
</template>

<script>
  export default {
    name: 'App',
    computed: {
      key() {
        return this.$route.name ? this.$route.name + new Date() : this.$route + new Date()
      }
    }
  }
</script>

<style>
  button {
    border: none;
    outline: none !important;
  }

  .title {
    /* width: 100px; */
    position: relative;
    line-height: 18px;
    text-align: left;
    text-indent: 20px;
    font-weight: bold;
  }

  .title1 {
    /*  width: 200px; */
    position: relative;
    line-height: 18px;
  }

  .el-select {
    margin: 0 !important;
  }

  .title::before {
    content: "";
    width: 4px;
    height: 18px;
    position: absolute;
    top: 0;
    left: 0;
    background: #C10B17;
  }

  .title1::before {
    content: "";
    width: 4px;
    height: 18px;
    position: absolute;
    top: 0;
    left: 0;
    background: #C10B17;
  }

  .el-select {
    width: 100px;
    margin: 0 10px;
  }

  .el-input-group__append {
    background-color: #C10B17;
    color: #ffffff;
  }

  .el-tabs__header {
    border-bottom: 1px solid #C10B17 !important;
  }

  .tabs .is-active {
    background-color: #C10B17;
    color: #ffffff !important;
    border-bottom: 1px solid #C10B17 !important;
  }

  .el-carousel__indicators .is-active {
    color: #3f8ec8 !important;
  }

  .is-active .el-carousel__button {
    background-color: #C10B17;
  }

  .el-radio__input.is-checked+.el-radio__label {
    color: #C10B17 !important;
  }

  .el-radio__input.is-checked .el-radio__inner {
    background: #C10B17 !important;
    border-color: #C10B17 !important;
  }

  .el-checkbox__input.is-checked .el-checkbox__inner,
  .el-checkbox__input.is-indeterminate .el-checkbox__inner {
    border-color: #C10B17 !important;
    background-color: #C10B17 !important;
  }

  .el-checkbox__input.is-focus .el-checkbox__inner {
    border-color: #C10B17 !important;
  }

  .el-checkbox__input.is-checked+.el-checkbox__label {
    color: #C10B17 !important;
  }

  .el-tabs__nav {
    border: none !important;
  }

  .el-tabs__item {
    width: 132px;
    height: 40px;

    border-radius: 4px 4px 0px 0px;
  }

  body {
    margin: 0;
    padding: 0;
  }

  ul li {
    list-style: none;
  }

  #app {
    font-family: 'Avenir', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;
    margin: 0;
    padding: 0;
  }

  .flex {
    display: flex;
    flex-direction: row;
    align-items: center;
    flex-wrap: wrap;
  }

  html,
  body,
  div,
  span,
  applet,
  object,
  iframe,
  h1,
  h2,
  h3,
  h4,
  h5,
  h6,
  p,
  blockquote,
  pre,
  a,
  abbr,
  acronym,
  address,
  big,
  cite,
  code,
  del,
  dfn,
  em,
  img,
  ins,
  kbd,
  q,
  s,
  samp,
  small,
  strike,
  strong,
  sub,
  sup,
  tt,
  var,
  b,
  u,
  i,
  center,
  dl,
  dt,
  dd,
  ol,
  ul,
  li,
  fieldset,
  form,
  label,
  legend,
  table,
  caption,
  tbody,
  tfoot,
  thead,
  tr,
  th,
  td,
  article,
  aside,
  canvas,
  details,
  embed,
  figure,
  figcaption,
  footer,
  header,
  hgroup,
  menu,
  nav,
  output,
  ruby,
  section,
  summary,
  time,
  mark,
  audio,
  video {
    margin: 0;
    padding: 0;
    border: 0;
    font-size: 100%;
    /* font: inherit; */
    vertical-align: baseline;
  }

  /* HTML5 display-role reset for older browsers */
  article,
  aside,
  details,
  figcaption,
  figure,
  footer,
  header,
  hgroup,
  menu,
  nav,
  section {
    display: block;
  }

  body {
    line-height: 1;
  }

  ol,
  ul {
    list-style: none;
  }

  blockquote,
  q {
    quotes: none;
  }

  blockquote:before,
  blockquote:after,
  q:before,
  q:after {
    content: '';
    content: none;
  }

  table {
    border-collapse: collapse;
    border-spacing: 0;
  }

  a {
    color: #FFFFFF;
    text-decoration: none;
  }

  html,
  body,
  div,
  h1,
  h2,
  h3,
  h4,
  h5,
  h6,
  p,
  dl,
  dt,
  dd,
  ol,
  ul,
  li,
  fieldset,
  form,
  label,
  input,
  legend,
  table,
  caption,
  tbody,
  tfoot,
  thead,
  tr,
  th,
  td,
  textarea,
  article,
  aside,
  audio,
  canvas,
  figure,
  footer,
  header,
  mark,
  menu,
  nav,
  section,
  time,
  video {
    margin: 0;
    padding: 0;
  }

  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    font-size: 100%;
    font-weight: normal
  }

  article,
  aside,
  dialog,
  figure,
  footer,
  header,
  hgroup,
  nav,
  section,
  blockquote {
    display: block;
  }

  ul,
  ol {
    list-style: none;
  }

  img {
    border: 0 none;
    vertical-align: top;
  }

  blockquote,
  q {
    quotes: none;
  }

  blockquote:before,
  blockquote:after,
  q:before,
  q:after {
    content: none;
  }

  table {
    border-collapse: collapse;
    border-spacing: 0;
  }

  strong,
  em,
  i {
    font-style: normal;
    font-weight: normal;
  }

  ins {
    text-decoration: underline;
  }

  del {
    text-decoration: line-through;
  }

  mark {
    background: none;
  }

  input::-ms-clear {
    display: none !important;
  }

  body {
    /*  font: 16px/1.5 \5FAE\8F6F\96C5\9ED1, \5B8B\4F53, "Hiragino Sans GB", STHeiti, "WenQuanYi Micro Hei", "Droid Sans Fallback", SimSun, sans-serif; */
    background: #fff;
  }

  a {
    text-decoration: none;
    color: #333;
  }

  a:hover {
    text-decoration: underline;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue